export default "/images/maintenance.svg?99e1ab21770af66281caef0477fe8332";